<template>
  <div class="switch-container">
    <label class="switch">
      <input :disabled="disabled" type="checkbox" v-model="selectedValue" @change="$emit('change', $event)">
      <span class="slider round"></span>
    </label>
    <span v-if="label" @click="updateValue">{{label}}</span>
  </div>
</template>

<script>
export default {
  name: 'CheckBoxV2',
  props: {
    value: {required: true},
    label: {type: String | Number, required: false},
    disabled: {type: Boolean, default: false}
  },

  computed: {
    selectedValue: {
      get () {
        return this.value
      },
      set (v) {
        return this.$emit('input', v)
      }
    }
  },

  methods: {
    updateValue () {
      if (this.disabled) return
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped>
.switch-container {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.switch-container span {
  padding-left: 8px;
  font-size: 0.82rem;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #1976D2;
}

input:disabled + .slider {
  background-color: #ccc;
  cursor: default;
}

input:focus + .slider {
  box-shadow: 0 0 1px #1976D2;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
